import { Trash2 } from "lucide-react";
import { eur } from "@/lib/api";

const SERVICE = { preventivo: "Preventivo", permuta: "Permuta", riparazione: "Riparazione", info: "Info" };
const PAY = { paid: "Pagato", pending: "In attesa", expired: "Scaduto", failed: "Fallito", refunded: "Rimborsato" };
const date = (s) => (s ? new Date(s).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "");
const Empty = ({ text, testid }) => <p className="py-16 text-center text-mist" data-testid={testid}>{text}</p>;

export const RequestsTable = ({ rows, onStatus, onDelete }) => {
  if (!rows.length) return <Empty text="Nessuna richiesta ancora." testid="admin-requests-empty" />;
  return (
    <div className="mt-4 grid gap-3" data-testid="admin-requests-list">
      {rows.map((r) => (
        <article key={r.id} data-testid={`admin-request-${r.id}`} className="grid gap-4 rounded-3xl border border-fg/10 bg-[var(--ink-2)] p-5 md:grid-cols-12">
          <div className="md:col-span-3">
            <p className="font-display text-lg">{r.name}</p>
            <p className="break-all text-sm text-mist">{r.email}</p>
            {r.phone && <p className="text-sm text-mist">{r.phone}</p>}
          </div>
          <div className="md:col-span-6">
            <p className="font-mono-ui text-xs uppercase tracking-widest text-[var(--volt)]">{SERVICE[r.service] || r.service} · {date(r.created_at)}</p>
            <p className="mt-1 whitespace-pre-line text-sm text-fg2">{r.message || "—"}</p>
            {r.items?.length > 0 && (
              <p className="mt-2 text-xs text-mist">Carrello: {r.items.map((i) => `${i.quantity}× ${i.name}`).join(", ")}</p>
            )}
          </div>
          <div className="flex items-start gap-2 md:col-span-3 md:justify-end">
            <select value={r.status} onChange={(e) => onStatus(r.id, e.target.value)} data-testid={`admin-request-status-${r.id}`}
              className="rounded-full border border-fg/20 bg-[var(--ink)] px-4 py-2 text-sm text-fg">
              <option value="nuova">Nuova</option>
              <option value="in_lavorazione">In lavorazione</option>
              <option value="chiusa">Chiusa</option>
            </select>
            <button onClick={() => onDelete(r)} data-testid={`admin-request-delete-${r.id}`} aria-label="Elimina richiesta"
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[var(--flare)] hover:bg-fg/10">
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        </article>
      ))}
    </div>
  );
};

export const OrdersTable = ({ rows, onDelete }) => {
  if (!rows.length) return <Empty text="Nessun ordine ancora." testid="admin-orders-empty" />;
  return (
    <div className="mt-4 grid gap-3" data-testid="admin-orders-list">
      {rows.map((o) => (
        <article key={o.id} data-testid={`admin-order-${o.id}`} className="grid gap-3 rounded-3xl border border-fg/10 bg-[var(--ink-2)] p-5 md:grid-cols-12 md:items-center">
          <div className="md:col-span-6">
            <p className="text-sm text-fg2">{(o.items || []).map((i) => `${i.quantity}× ${i.name}`).join(", ")}</p>
            <p className="mt-1 text-xs text-mist">{date(o.created_at)} {o.customer_email ? `· ${o.customer_email}` : ""}</p>
          </div>
          <p className="font-display text-2xl md:col-span-3">{eur(o.amount)}</p>
          <div className="flex items-center gap-2 md:col-span-3 md:justify-self-end">
            <span data-testid={`admin-order-status-${o.id}`} className={`w-fit rounded-full px-3 py-1 text-xs ${o.payment_status === "paid" ? "bg-[var(--volt)] text-[var(--ink)]" : "bg-fg/10 text-fg2"}`}>
              {PAY[o.payment_status] || o.payment_status}
            </span>
            {!["paid", "refunded"].includes(o.payment_status) && (
              <button onClick={() => onDelete(o)} data-testid={`admin-order-delete-${o.id}`} aria-label="Elimina ordine"
                className="flex h-9 w-9 items-center justify-center rounded-full text-[var(--flare)] hover:bg-fg/10">
                <Trash2 className="h-4 w-4" />
              </button>
            )}
          </div>
        </article>
      ))}
    </div>
  );
};
